var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_4165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.676 36.2511C27.8865 36.2511 36.206 23.7455 36.206 12.9007C36.206 12.5455 36.206 12.1919 36.1818 11.8399C37.8003 10.6781 39.1974 9.23973 40.3077 7.59191C38.7984 8.25559 37.1972 8.69074 35.5578 8.88309C37.2838 7.85777 38.5764 6.24387 39.1936 4.34387C37.5703 5.29973 35.7942 5.97348 33.9423 6.3359C32.3787 4.68582 30.1948 3.74902 27.9124 3.74902C23.3714 3.74902 19.6348 7.45715 19.6348 11.9634C19.6348 12.5886 19.7068 13.2118 19.8491 13.8207C13.2032 13.4901 7.0026 10.3706 2.8054 5.24629C0.622801 8.97488 1.75212 13.8069 5.36573 16.2014C4.04982 16.1628 2.76218 15.8104 1.61231 15.1743V15.2782C1.61341 19.17 4.40291 22.5525 8.24694 23.3231C7.02952 23.6525 5.75188 23.7007 4.51289 23.4639C5.59356 26.7986 8.70985 29.0973 12.2391 29.1631C9.31124 31.4464 5.69244 32.6868 1.96862 32.6831C1.31063 32.6818 0.653268 32.6423 0 32.5646C3.78152 34.9728 8.18278 36.2506 12.676 36.2446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_4165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3077,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.79ddab146cf95649d0b8e50180f0b0a1.svg";
export { ForwardRef as ReactComponent };